<script lang="ts" setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useSmartSocietyAuthStore } from '@/stores/smartSocietyAuthStore'

const authStore = useSmartSocietyAuthStore()
const router = useRouter()

const user = computed(() => {
  if (!authStore.user) {
    return null
  }

  return {
    id: 1,
    first_name: authStore.user.given_name ?? authStore.user.name ?? 'User',
    email: authStore.user.email ?? ''
  }
})

async function logout() {
  await authStore.logout()
  await router.replace({ name: 'auth-login' })
}
</script>

<template>
  <v-app-bar
    v-if="user"
    class="app-header"
    color="primary"
    density="comfortable"
    elevation="0"
    height="48"
  >
    <div class="app-header__twinn" aria-label="Haskoning">
      <span class="app-header__twinn-text">Twinn</span>
    </div>
    <div class="app-header__brand" aria-label="Haskoning">
      <span class="app-header__logo-text">Haskoning</span>
    </div>

    <v-spacer />

    <v-menu location="bottom end">
      <template #activator="{ props }">
        <v-btn
          icon="mdi-account-circle"
          v-bind="props"
          class="app-header__user-trigger"
          color="white"
          variant="text"
          size="32"
          aria-label="Open account menu"
        >
      
        </v-btn>
      </template>

      <v-list min-width="240">
        <v-list-item :title="user.first_name" :subtitle="user.email || undefined" />
        <v-divider />
        <v-list-item title="Logout" @click="logout" />
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<style scoped>
.app-header {
  /* Available local weights are 400, 700 and 900. Use stroke for in-between tuning. */
  --app-header-logo-size: 1.35rem;
  --app-header-logo-weight: 700;
  --app-header-logo-letter-spacing: -0.022em;
  --app-header-logo-stroke-width: 0px;
}

.app-header__brand {
  position: absolute;
  top: 50%;
  left: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transform: translate(-50%, -50%);
  pointer-events: none;
}

.app-header__twinn {
  position: absolute;
  top: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transform: translate(8px, -50%);
  pointer-events: none;
}

.app-header__user {
  margin-right: 4px;
  text-transform: none;
}

.app-header__logo-text {
  display: block;
  max-width: min(180px, calc(100vw - 180px));
  overflow: hidden;
  color: #ffffff;
  font-family: 'Gilroy', sans-serif;
  font-size: var(--app-header-logo-size);
  font-weight: var(--app-header-logo-weight);
  letter-spacing: var(--app-header-logo-letter-spacing);
  -webkit-text-stroke: var(--app-header-logo-stroke-width) currentColor;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.app-header__twinn-text {
  display: block;
  max-width: min(180px, calc(100vw - 180px));
  overflow: hidden;
  color: #ffffff;
  font-family: 'Gilroy', sans-serif;
  font-size: 1.05rem;
  font-weight: var(--app-header-logo-weight);
  letter-spacing: var(--app-header-logo-letter-spacing);
  -webkit-text-stroke: var(--app-header-logo-stroke-width) currentColor;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 700px) {
  .app-header {
    --app-header-logo-size: 22px;
  }

  .app-header__logo-text {
    max-width: min(160px, calc(100vw - 140px));
  }
}
</style>
